import { formFields } from "./field-names";

export const DETAIL = {
  progress: [
    // {
    //   step: 1,
    //   title: "Thủ trưởng cơ quan đơn vị",
    //   NBTitle:"Trưởng phòng KHHC"
    // },
    // {
    //   step: 2,
    //   title: "Bộ phận đào tạo TCNL",
    //   NBTitle:"Giám đốc chi nhánh"
    // }
    // ,
    {
      step: 1,
      title: "Trưởng phòng TCNL",
      NBTitle: "Trưởng phòng KHHC",
    },
    {
      step: 2,
      title: "Tổng Giám đốc",
      NBTitle: "Giám đốc chi nhánh",
    },
  ],
  information: formFields.map((value) => {
    return {
      field: value.field,
      label: value.label,
    };
  }),
};
